import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from './AbstractList.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  copyToArray2j022khrow2yi as copyToArray,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './collectionJs.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { indexOf3ic8eacwbbrog as indexOf } from './_Arrays.mjs';
import { arrayToString1r7op7afgkivw as arrayToString } from './collectionsHacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from './Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().i2(0);
        this_0.h2_1 = true;
        tmp.f8_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function increaseLength($this, amount) {
  var previous = $this.q2();
  // Inline function 'kotlin.js.asDynamic' call
  $this.g2_1.length = $this.q2() + amount | 0;
  return previous;
}
function rangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.j7(index, $this.q2());
  return index;
}
function insertionRangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.a7(index, $this.q2());
  return index;
}
var ArrayListClass;
function ArrayList() {
  if (ArrayListClass === VOID) {
    class $ extends AbstractMutableList() {
      constructor(array) {
        return new.target.h6(array);
      }
      static h6(array) {
        Companion_getInstance();
        var $this = this.i7();
        $this.g2_1 = array;
        $this.h2_1 = false;
        return $this;
      }
      static p2() {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        return this.h6(tmp$ret$0);
      }
      static i2(initialCapacity) {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        var $this = this.h6(tmp$ret$0);
        // Inline function 'kotlin.require' call
        if (!(initialCapacity >= 0)) {
          var message = 'Negative initial capacity: ' + initialCapacity;
          throw IllegalArgumentException().o2(toString(message));
        }
        return $this;
      }
      static k2(elements) {
        Companion_getInstance();
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(elements);
        return this.h6(tmp$ret$0);
      }
      g8() {
        this.p6();
        this.h2_1 = true;
        return this.q2() > 0 ? this : Companion_getInstance().f8_1;
      }
      h8() {
      }
      i8(minCapacity) {
      }
      q2() {
        return this.g2_1.length;
      }
      r2(index) {
        return this.g2_1[rangeCheck(this, index)];
      }
      j3(index, element) {
        this.p6();
        rangeCheck(this, index);
        // Inline function 'kotlin.apply' call
        var this_0 = this.g2_1[index];
        this.g2_1[index] = element;
        return this_0;
      }
      j2(element) {
        this.p6();
        // Inline function 'kotlin.js.asDynamic' call
        this.g2_1.push(element);
        this.v6_1 = this.v6_1 + 1 | 0;
        return true;
      }
      z4(index, element) {
        this.p6();
        // Inline function 'kotlin.js.asDynamic' call
        this.g2_1.splice(insertionRangeCheck(this, index), 0, element);
        this.v6_1 = this.v6_1 + 1 | 0;
      }
      u2(elements) {
        this.p6();
        if (elements.n1())
          return false;
        var offset = increaseLength(this, elements.q2());
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = elements.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var index_0 = checkIndexOverflow(_unary__edvuaz);
          this.g2_1[offset + index_0 | 0] = item;
        }
        this.v6_1 = this.v6_1 + 1 | 0;
        return true;
      }
      a5(index) {
        this.p6();
        rangeCheck(this, index);
        this.v6_1 = this.v6_1 + 1 | 0;
        var tmp;
        if (index === get_lastIndex(this)) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.g2_1.pop();
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.g2_1.splice(index, 1)[0];
        }
        return tmp;
      }
      k7(fromIndex, toIndex) {
        this.p6();
        this.v6_1 = this.v6_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        this.g2_1.splice(fromIndex, toIndex - fromIndex | 0);
      }
      y4() {
        this.p6();
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.g2_1 = [];
        this.v6_1 = this.v6_1 + 1 | 0;
      }
      s4(element) {
        return indexOf(this.g2_1, element);
      }
      toString() {
        return arrayToString(this.g2_1);
      }
      j8() {
        return [].slice.call(this.g2_1);
      }
      toArray() {
        return this.j8();
      }
      p6() {
        if (this.h2_1)
          throw UnsupportedOperationException().k8();
      }
    }
    initMetadataForClass($, 'ArrayList', $.p2, VOID, [KtMutableList(), RandomAccess()]);
    ArrayListClass = $;
  }
  return ArrayListClass;
}
//region block: exports
export {
  ArrayList as ArrayList3it5z8td81qkl,
};
//endregion

//# sourceMappingURL=ArrayListJs.mjs.map
